/*
 * Paints the portal in the company's own primary colour.
 *
 * The theme reads its primary colour from Bootstrap's CSS variables, so a
 * company colour only has to replace those. Buttons carry their own copies of
 * the colour, so they are restated here too. A company with no colour of its
 * own keeps the theme's.
 */
const STYLE_ID = "company-branding";
const HEX = /^#[0-9a-f]{6}$/i;

const toRgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));

/** The colour mixed with black by `amount` (0–1): for hover and pressed states. */
const darken = (hex, amount) =>
  "#" + toRgb(hex).map((c) => Math.round(c * (1 - amount)).toString(16).padStart(2, "0")).join("");

export const applyBranding = (company) => {
  const colour = company?.primary_color;
  document.getElementById(STYLE_ID)?.remove();

  if (!colour || !HEX.test(colour)) return;

  const rgb = toRgb(colour).join(", ");
  const hover = darken(colour, 0.1);
  const active = darken(colour, 0.2);

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
:root, [data-bs-theme] {
  --bs-primary: ${colour};
  --bs-primary-rgb: ${rgb};
  --bs-link-color: ${colour};
  --bs-link-color-rgb: ${rgb};
  --bs-link-hover-color: ${hover};
  --bs-link-hover-color-rgb: ${toRgb(hover).join(", ")};
  --bs-primary-text-emphasis: ${active};
  --bs-primary-bg-subtle: rgba(${rgb}, 0.12);
  --bs-primary-border-subtle: rgba(${rgb}, 0.35);
}
.btn-primary {
  --bs-btn-bg: ${colour}; --bs-btn-border-color: ${colour};
  --bs-btn-hover-bg: ${hover}; --bs-btn-hover-border-color: ${hover};
  --bs-btn-active-bg: ${active}; --bs-btn-active-border-color: ${active};
  --bs-btn-disabled-bg: ${colour}; --bs-btn-disabled-border-color: ${colour};
  --bs-btn-focus-shadow-rgb: ${rgb};
}
.btn-outline-primary {
  --bs-btn-color: ${colour}; --bs-btn-border-color: ${colour};
  --bs-btn-hover-bg: ${colour}; --bs-btn-hover-border-color: ${colour};
  --bs-btn-active-bg: ${colour}; --bs-btn-active-border-color: ${colour};
  --bs-btn-disabled-color: ${colour}; --bs-btn-disabled-border-color: ${colour};
  --bs-btn-focus-shadow-rgb: ${rgb};
}
.form-check-input:checked { background-color: ${colour}; border-color: ${colour}; }
.form-control:focus, .form-select:focus { border-color: rgba(${rgb}, 0.5); }
.nav-pills { --bs-nav-pills-link-active-bg: ${colour}; }
.pagination { --bs-pagination-active-bg: ${colour}; --bs-pagination-active-border-color: ${colour}; }
.progress, .progress-stacked { --bs-progress-bar-bg: ${colour}; }
`;
  document.head.appendChild(style);
};
